import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { url } from 'statics';
import { CreateDepositBankTransfer, ErrorResponse } from 'types';

import { api } from 'utils';

const useDepositBankTransfer = (): UseMutationResult<
  { id: string },
  ErrorResponse,
  CreateDepositBankTransfer
> => {
  return useMutation((data) => api.post(url.depositBankTransfer, data));
};

export default useDepositBankTransfer;
